import { memo } from 'react';
import { pricingStore } from '~/lib/stores/pricing/pricing';
import { PricingPageOpenedTrigger } from '~/types/analytics';
import { classNames } from '~/utils/classNames';

interface UpgradeLinkProps {
  text?: string;
  className?: string;
  onClick?: VoidFunction;
}

function showPricingOverlay() {
  pricingStore.openPricingOverlay(PricingPageOpenedTrigger.UpgradePlanLink);
}

export const UpgradeLink = memo<UpgradeLinkProps>(({ className, text, onClick }) => {
  return (
    <button
      className={classNames(className, 'bg-transparent text-bolt-elements-messages-linkColor hover:underline')}
      onClick={() => {
        onClick?.();
        showPricingOverlay();
      }}
    >
      {text || 'Upgrade'}
    </button>
  );
});
